import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-printbill',
  templateUrl: './printbill.component.html',
  styleUrls: ['./printbill.component.css']
})
export class PrintbillComponent implements OnInit {

  constructor() {
    // let bill_no = this.activatedroute.snapshot.params['id'];
   }

  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// D:/xampp/htdocs/tejashree/src/app/printbill/printbill.component.ts